import { WordPredictionService } from './../word-prediction/word-prediction.service';
import { Injectable } from '@angular/core';
import { SpellCheckService } from '../spell-check/spell-check.service';
import { DocumentHighlightService } from './document-highlight.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentKeyboardHandlerService {

  constructor(
    private readonly spellCheckerService: SpellCheckService,
    private readonly docHighlight: DocumentHighlightService,
    private wordPredictionService: WordPredictionService,
  ) { }

  handleDocumentKeyPressed = (e: KeyboardEvent) => {
    this.docHighlight.cleanCurrentHighlight(true);
    this.spellCheckerService.init(e);
    this.wordPredictionService.onKeyUpHandler(e);
  }

  handleKeyDownSpellCheck = (e: KeyboardEvent) => {
    this.spellCheckerService.onKeyDownSpellCheck(e);
  }
}
